import { deserialize } from 'cerialize'
import { CreatorModel } from '../Contracts/ContractCreator'
import { PublicationModel } from './PublicationModel'
import { ReportContractModel } from './ReportContract'

export class ReportsModel {
	@deserialize public id: number
	@deserialize public number: string | null
	@deserialize public date: string
	@deserialize public amount: string
	@deserialize public registered_at: string | null
	@deserialize public status: string
	@deserialize public publications: PublicationModel[]
	@deserialize public contract: ReportContractModel
	@deserialize public created_by_user: {
		id: number
		name: string
	}
	@deserialize public start_date: string
	@deserialize public end_date: string
	@deserialize public contractor: CreatorModel
}
